export class SchoolEnrollmentDetailsAsl {
    ID: number;
    SCHOOL_YEAR: string;
    GRADE: string;
    GRADE_INDEX: string;
    TRACK: string;
    RECRUITER_SIGN_DATE: Date;
    ENROLLMENT_TYPE: string;
    ENROLLMENT_DATE: Date;
    WITHDRAWAL_DATE: Date;
    DEPARTURE_DATE: Date;
    ACADEMIC_RISK: string;
    PFS: string;
    COS: string;
    SOURCE: string;
    VERIFIED: boolean;
    SCHOOL_NAME: string;
    COES: any[];
    STUDENT_ELIGIBILITIES: any[];
}
